<template>
  <div class="performance-report">
    <el-row class="bgW" :gutter="20">
      <el-col :span="20">
        <el-form 
          class="c" 
          :inline="true" 
          label-suffix="：" 
          size="mini" 
          :model="search"
        >
          <el-form-item label="日期">
            <el-date-picker
              v-model="search.start_time"
              type="date"
              class="w130"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              :clearable="true"
            />
            <span class="mx-2">-</span>
            <el-date-picker
              v-model="search.end_time"
              type="date"
              class="w130"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :clearable="true"
            />
          </el-form-item>
          <el-form-item label="归属市场">
            <el-select v-model="search.market_id" filterable clearable class="w150" placeholder="请选择统归属市场">
              <el-option
                v-for="item in options.marketIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="门店/门诊" >
            <el-select
              v-model="search.shop_id"
              clearable
              remote
              filterable
              :remote-method="remoteShop"
              placeholder="请输入"
              class="w120"
            >
              <el-option
                v-for="item in options.shopIdList"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="门店类型">
            <el-select
              v-model="search.shop_type"
              placeholder="请选择门店类型"
              class="w130"
              clearable
            >
              <el-option
                v-for="item in options.shop_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      
      <el-col :span="4" class="btnBox">
        <el-button 
          type="primary" 
          icon="el-icon-search" 
          size="mini" 
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button 
          type="primary" 
          icon="el-icon-plus" 
          size="mini" 
          @click="openAddTargetDialog"
        >
          添加目标
        </el-button>
      </el-col>
    </el-row>
    
    <el-table
      ref="table"
      :data="processedTableData"
      :span-method="dynamicSpanMethod"
      border
      style="width: 100%; margin-top: 20px;"
      max-height="700px"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      v-loading="loading"
    >
      <el-table-column prop="marketName" label="市场名称" width="120" align="center" />
      <el-table-column prop="shopName" label="门店" width="110" align="center" />
      <el-table-column prop="category" label="类目" align="center" />
      <el-table-column prop="enterShopCount" label="进店个数" align="center" />
      <el-table-column prop="newOrderCount" label="新单个数" align="center" />
      <el-table-column prop="newOrderAmount" label="新单金额" align="center" />
      <el-table-column prop="supplementAmount" label="补单金额" align="center" />
      <el-table-column prop="nursingVolume" label="护理量" align="center" />
      <el-table-column prop="nursingPeople" label="护理人数" align="center" />
      <el-table-column prop="retainPeople" label="保有人数" align="center" />
      <el-table-column prop="consumeAmount" label="消耗金额" align="center" />
      <el-table-column prop="totalPerformance" label="总业绩" align="center" />
    </el-table>

    <!-- 目标值设置弹窗（修改后的添加目标弹窗） -->
    <el-dialog
      title="添加目标值"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      @close="resetDialog"
    >
      <el-form :model="targetForm" label-width="120px" @submit.native.prevent :rules="targetRules" ref="targetFormRef">
            <el-form-item label="选择年月" prop="year_month">
              <el-date-picker
                v-model="targetForm.year_month"
                type="month"
                placeholder="选择年月"
                value-format="yyyy-MM"
                style="width: 60%"
                :clearable="false"
              />
            </el-form-item>
            <el-form-item label="选择门店" prop="shop_id">
              <el-select
                v-model="targetForm.shop_id"
                clearable
                remote
                filterable
                :remote-method="remoteShop"
                placeholder="请输入门店名称搜索"
                style="width: 60%"
              >
                <el-option
                  v-for="item in options.shopIdList"
                  :key="item.shopId"
                  :label="item.shopName"
                  :value="item.shopId"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="目标类型" prop="type">
              <el-select
                v-model="targetForm.type"
                placeholder="请选择目标类型"
                style="width: 60%"
                clearable
              >
                <el-option v-for="item in options.typeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="目标值" prop="target">
              <el-input
                v-model.number="targetForm.target"
                type="number"
                placeholder="请输入目标值"
                min="0"
                step="0.01"
                style="width: 60%"
              />
            </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTarget">确认添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { shopTargetList, getTargetType, upShopTarget,getShopType } from '@/api/statistics'
import { readAdminMarketList, getShopList } from "@/api/shop";

// 搜索参数类
class SearchParams {
  constructor() {
    this.start_time = ''
    this.end_time = ''
    this.market_id = ''  
    this.shop_id = ''      
    this.shop_type = ''
  }
}
class Options {
  marketIdList = [];
  shopIdList = [];
  typeOptions = [];
  shop_type = [];
}

export default {
  name: 'PerformanceReport',
  data() {
    return {
      options: new Options(),
      search: new SearchParams(),
      loading: false,
      allStores: [], 
      rawTableData: [],
      processedTableData: [],
      spanInfo: {
        marketName: [], 
        shopName: []       
      },
      
      // 弹窗相关配置
      dialogVisible: false,
      targetForm: {
        year_month: '', // 年月
        shop_id: '',    // 门店ID
        type: '',       // 类型（直营/加盟）
        target: ''// 目标值
      },
      targetRules: { // 表单校验规则
        year_month: [{ required: true, message: '请选择年月', trigger: 'change' }],
        shop_id: [{ required: true, message: '请选择门店', trigger: 'change' }],
        type: [{ required: true, message: '请选择目标类型', trigger: 'change' }],
        target: [
          { required: true, message: '请输入目标值', trigger: 'blur' },
          { type: 'number', min: 0, message: '目标值必须大于等于0', trigger: 'blur' }
        ]
      },
      targetFormRef: null,
      
      // 表头样式
      headerCellStyle: {
        background: '#E9EDEE', 
        textAlign: 'center',
        fontWeight: 'bold'
      }
    }
  },
  
  mounted() {
    this.initData()
    this.getOptions()
  },
  
  methods: {
    cellStyle({columnIndex,rowIndex}){
      if(columnIndex <= 1){
          return 'background:#D9E1F4;text-align:center'
      }
      if(rowIndex % 3 === 0){
          return 'background:#F5F7FC;text-align:center'
      }
      if(rowIndex % 3 === 1){
          return 'background:#E7ECF7;text-align:center'
      }
      if(rowIndex % 3 === 2){
          return 'background:#D9E1F4;text-align:center'
      }
      return '';
    },
    getOptions() {
      readAdminMarketList().then(res => {
        this.options.marketIdList = res.list;
      });
      this.remoteShop('')
      getTargetType().then(res => {
        this.options.typeOptions = res.data;
      })
      getShopType().then(res => {
        this.options.shop_type = res.data;
      })
    },
    remoteShop(e) {
      getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
        this.options.shopIdList = res.list;
      });
    },
    async initData() {
      this.loading = true
      this.getshopTargetList()
    },
    async getshopTargetList() {
      this.loading = true
      try {
        const res = await shopTargetList(this.search)
        if (res.code === 200) {
          this.processedTableData = res.data || []
          this.processTableData(this.processedTableData)
        } else {
          this.$message.error(res.message || '获取数据失败')
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.getshopTargetList()
    },
    resetSearch() {
      this.search = new SearchParams()
      this.getshopTargetList()
    },
    dynamicSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return this.spanInfo.marketName[rowIndex]
      }
      if (columnIndex === 1) {
        return this.spanInfo.shopName[rowIndex]
      }
    },
    
    // 打开添加目标弹窗
    openAddTargetDialog() {
      this.dialogVisible = true
      // 默认选中当前年月
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      this.targetForm.year_month = `${year}-${month}`
    },
    
    /**
     * 提交添加目标
     */
    async submitTarget() {
      // 表单校验
      try {
        await this.$refs.targetFormRef.validate()
      } catch (error) {
        this.$message.warning('请完善必填信息')
        return
      }
      
      try {
        // 1. 调用添加目标的接口（这里先用upShopTarget示例，实际需替换为新增接口）
        const res = await upShopTarget({
          shop_id: this.targetForm.shop_id,
          type: this.targetForm.type,
          target: this.targetForm.target,
          year_month: this.targetForm.year_month.replace('-', ''),
        })
        
        if (res.code === 200) {
          this.$message.success('目标添加成功')
          this.dialogVisible = false
          // 刷新表格数据
          this.getshopTargetList()
        } else {
          this.$message.error(res.message || '目标添加失败')
        }
      } catch (error) {
        console.error('添加目标失败:', error)
        this.$message.error('目标添加失败')
      }
    },
    
    /**
     * 获取列索引
     */
    getColumnIndex(prop) {
      const columns = [
        'marketName', 'shopName', 'category', 'enterShopCount', 'newOrderCount',
        'newOrderAmount', 'supplementAmount', 'nursingVolume', 'nursingPeople',
        'retainPeople', 'consumeAmount', 'totalPerformance'
      ]
      return columns.indexOf(prop)
    },
    processTableData(rawData) {
      if (!rawData || !rawData.length) {
        this.processedTableData = []
        return
      }

      const processedData = []
      const marketNameSpan = []
      const storeSpan = []
      
      // 按市场分组
      const marketGroups = {}
      rawData.forEach((item, index) => {
        const market = item.marketName
        if (!marketGroups[market]) {
          marketGroups[market] = []
        }
        marketGroups[market].push({ ...item, originalIndex: index })
      })
      
      let currentRow = 0
      
      // 处理每个市场
      Object.keys(marketGroups).forEach(market => {
        const marketItems = marketGroups[market]
        
        // 按门店分组
        const storeGroups = {}
        marketItems.forEach(item => {
          const shopName = item.shopName || ''
          if (!storeGroups[shopName]) {
            storeGroups[shopName] = []
          }
          storeGroups[shopName].push(item)
        })
        
        const marketRows = Object.values(storeGroups).flat().length
        const marketStartRow = currentRow
        
        marketNameSpan[currentRow] = {
          rowspan: marketRows,
          colspan: 1
        }
        
        for (let i = 1; i < marketRows; i++) {
          marketNameSpan[currentRow + i] = { rowspan: 0, colspan: 0 }
        }
        
        Object.keys(storeGroups).forEach(shopName => {
          const storeItems = storeGroups[shopName]
          const storeRows = storeItems.length
          const storeStartRow = currentRow
          
          if (shopName) { // 门店不为空时才合并
            storeSpan[currentRow] = {
              rowspan: storeRows,
              colspan: 1
            }
            
            for (let i = 1; i < storeRows; i++) {
              storeSpan[currentRow + i] = { rowspan: 0, colspan: 0 }
            }
          }
          
          storeItems.forEach(item => {
            processedData.push(item)
            currentRow++
          })
        })
        
        currentRow = marketStartRow + marketRows
      })
      
      for (let i = 0; i < processedData.length; i++) {
        if (!marketNameSpan[i]) marketNameSpan[i] = { rowspan: 1, colspan: 1 }
        if (!storeSpan[i]) storeSpan[i] = { rowspan: 1, colspan: 1 }
      }
      
      this.spanInfo = {
        marketName: marketNameSpan,
        shopName: storeSpan
      }
      this.processedTableData = processedData
    },
    
    /**
     * 重置弹窗
     */
    resetDialog() {
      this.targetForm = {
        year_month: '',
        shop_id: '',
        type: '',
        target: ''
      }
      // 重置表单校验
      if (this.$refs.targetFormRef) {
        this.$refs.targetFormRef.resetFields()
      }
    }
  }
}
</script>

<style scoped>
.performance-report {
  padding: 20px;
  background: #fff;
  min-height: 100%;
}

.mx-2 {
  margin: 0 8px;
}

:deep(.el-table__header .el-table__cell) {
  font-weight: bold;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

:deep(.el-form-item) {
  margin-bottom: 20px;
  margin-right: 16px;
}

:deep(.el-form-item:last-child) {
  margin-right: 0;
}

:deep(.el-form-item__label) {
  font-weight: normal;
  color: #606266;
}

.w130 {
  width: 130px;
}

.w100 {
  width: 100%;
}

.btnBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding-right: 20px;
}

/* 日期范围选择器之间的间隔 */
:deep(.el-date-editor) {
  margin: 0 !important;
}

/* 响应式调整 */
@media screen and (max-width: 1400px) {
  .w130 {
    width: 110px;
  }
  
  :deep(.el-form-item) {
    margin-right: 8px;
  }
}
</style>